// extracted by mini-css-extract-plugin
module.exports = {"filterWidth":"238px"};